import React, { Component, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

// --- children: ReactNode - The child components that this boundary will monitor for errors. ---
type ErrorBoundaryProps = {
  children: ReactNode;
};

// --- hasError: boolean - Indicates whether an error has been caught. ---
// --- error: Error | undefined - Stores the actual error object that was thrown. ---
type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    /**
     * Called when a child component throws an error.
     */
    static getDerivedStateFromError(error: Error) {
        return { hasError: true, error };
    }

    /**
     * Called after an error has been thrown by a child component.
     */
    componentDidCatch() {
        
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h4" color="error">Something went wrong.</Typography>
                <Typography variant="body1" color="textSecondary">{this.state.error?.message}</Typography>
                </Box>
            );
        }

        return this.props.children;
    }
};

export default ErrorBoundary;